<template>
  <div class="ident-view container fluid">
    <v-card v-if="!isLoadingProviders">
      <ident-toolbar
        :on-user-select="onUserSelect"
        :is-loading-user-detail="isLoadingUserDetail"
        :current-user="currentUser"
      />
      <div class="fab-container">
        <!-- FAB START -->
        <v-speed-dial
          v-model="fabActive"
          direction="left"
          open-on-hover
        >
          <template v-slot:activator>
            <v-btn
              v-model="fabActive"
              color="warning"
              fab
            >
              <v-icon>group_add</v-icon>
              <v-icon>close</v-icon>
            </v-btn>
          </template>
          <v-btn
            color="success"
            round
            @click="toggleCreating"
          >
            <v-icon dark>
              add_a_photo
            </v-icon>
            <span class="ml-2">Create ident case</span>
          </v-btn>
          <v-btn
            color="info"
            dark
            round
            @click="toggleImport"
          >
            <v-icon dark>
              import_export
            </v-icon>
            <span class="ml-2">Import ident case</span>
          </v-btn>
        </v-speed-dial>
        <!-- FAB END -->
      </div>
      <v-card-title
        v-if="currentUser"
        class="toolbar blue-grey lighten-5 secondary--text"
      >
        <div
          class="d-flex"
          style="align-items: center"
        >
          <span class="headline">
            <v-avatar>
              <v-icon>perm_contact_calendar</v-icon>
            </v-avatar>
            <strong>
              Ident results for {{ currentUser.first_name }} {{ currentUser.last_name }}
            </strong>
          </span>
          <strong class="ml-2">id:</strong>{{ currentUser.id }}
          <strong class="ml-2">email:</strong>{{ currentUser.email }}
        </div>
      </v-card-title>

      <v-progress-linear
        v-if="isLoadingUserDetail"
        :indeterminate="true"
        class="ma-0"
      />

      <v-divider v-if="!currentUser" />

      <idents-table :current-user="currentUser" />
    </v-card>

    <!-- CREATE NEW IDENT DIALOG -->
    <CreateIdentDialog
      :is-open="isCreating"
      :toggle-open="toggleCreating"
      :on-user-select="onUserSelect"
      :is-loading-user-detail="isLoadingUserDetail"
      :current-user="currentUser"
    />

    <!-- IMPORT IDENT DIALOG -->
    <ImportIdentDialog
      :is-open="isImporting"
      :toggle-open="toggleImport"
      :on-user-select="onUserSelect"
      :is-loading-user-detail="isLoadingUserDetail"
      :current-user="currentUser"
    />
  </div>
</template>

<script>
import { setQuery } from '@/helpers';
import CreateIdentDialog from '@/components/ident/dialog/create/CreateIdentDialog';
import ImportIdentDialog from '@/components/ident/dialog/import/ImportIdentDialog';
import IdentToolbar from '@/components/ident/IdentToolbar';
import IdentsTable from '@/components/ident/IdentsTable';

export default {
  name: 'IdentView',
  components: {
    CreateIdentDialog,
    ImportIdentDialog,
    IdentToolbar,
    IdentsTable,
  },
  data() {
    return {
      isCreating: false,
      isImporting: false,
      fabActive: false,
      currentUser: null,
      isLoadingUserDetail: false,
      isLoadingIdents: false,
      isLoadingProviders: true,
    };
  },
  async beforeCreate() {
    // make sure we have the ident providers list before rendering the View components
    await this.$store.dispatch('fetchIdentProviders');
    this.isLoadingProviders = false;
  },

  mounted() {
    if (this.$route.query.userId) {
      this.fetchUserDetail(this.$route.query.userId);
    }
  },
  methods: {
    updateQuery(update) {
      setQuery({ ...this.$route.query, ...update }, this.$route, this.$router);
    },

    fetchUserDetail(val) {
      this.isLoadingUserDetail = true;
      this.$store
        .dispatch('getOnboardingUserById', val)
        .then((data) => {
          const { userMetaData, cognitoUserPoolData } = data;

          const email = cognitoUserPoolData.UserAttributes.find(obj => obj.Name === 'email').Value;
          const { naturalUser } = userMetaData.data;

          const result = {
            id: userMetaData.user_id,
            first_name: naturalUser.firstName,
            last_name: naturalUser.lastName,
            email,
          };

          this.onUserSelect(result);
        })
        .finally(() => {
          this.isLoadingUserDetail = false;
        });
    },

    onUserSelect(user = null) {
      if (!user) {
        this.clearUser();

        return null;
      }
      this.currentUser = user;
      this.$forceUpdate();

      this.updateQuery({
        userId: this.currentUser.id,
      });

      return null;
    },

    toggleCreating() {
      this.isCreating = !this.isCreating;
    },

    toggleImport() {
      this.isImporting = !this.isImporting;
    },

    clearUser() {
      this.currentUser = null;
      this.$forceUpdate();

      this.updateQuery({
        userId: null,
      });
    },
  },
};
</script>

<style lang="scss">
.ident-view {
  .toolbar {
    position: relative;
    padding: 24px 24px 16px 24px;
  }
  .separator {
    margin: 24px 0;
  }
  .fab-container {
    position: relative;
    .v-speed-dial {
      position: absolute;
      right: 0;
      top: -34px;
      z-index: 2;
    }
  }

  .headline {
    align-items: center;
    display: inline-flex;
  }
  .v-list__tile {
    padding: 16px;
    height: auto;
  }
  .v-card__title {
    justify-content: flex-start;
    padding: 24px;
  }
  .layout {
    padding: 24px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ident/IdentView.vue